import React, { useState, useEffect, useMemo } from 'react';
import ReactDOM from 'react-dom';
import { Button, Form, Spinner, Col } from 'react-bootstrap';
import { X, Check, Copy, Eye, EyeOff, Shield, Calendar, Phone, Mail, User, Clock, PlusCircle, AlertCircle, Briefcase, Target } from 'react-feather';
import { Icon } from '@iconify/react/dist/iconify.js';
import { toast } from 'react-toastify';
import { createAppUser, getSubscriptions, getProfessionalSituation } from '../helper/Api/AdminApi';

const customStyles = `
/* Drawer overlay styles - exact match with FilterUserDrawer */
body.drawer-open {
  overflow: hidden !important;
}

.drawer-backdrop {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  background-color: rgba(0, 0, 0, 0.4) !important;
  z-index: 1049 !important;
  animation: fadeIn 0.3s ease;
  pointer-events: auto !important;
  cursor: default !important;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideIn {
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
}

.user-drawer {
  position: fixed !important;
  right: 0 !important;
  top: 0 !important;
  bottom: 0 !important;
  height: 100vh !important;
  width: 572px !important;
  max-width: 100vw !important;
  background-color: #FFFFFF !important;
  box-shadow: -5px 0 25px rgba(0,0,0,0.15) !important;
  z-index: 1050 !important;
  overflow-y: hidden !important;
  overflow-x: hidden !important;
  box-sizing: border-box !important;
  pointer-events: auto !important;
  transform: translateX(0);
  animation: slideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  display: flex !important;
  flex-direction: column !important;
}

.user-drawer * {
  box-sizing: border-box !important;
  pointer-events: auto !important;
}

.user-avatar {
  width: 48px !important;
  height: 48px !important;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 20px;
  background-color: #CBA37033;
  color: #CBA370;                         
}

.personal-fields {
  border: 1px solid #F1F5F9 !important;
  background-color: #FFFFFF;
  border-radius: 10px;
  padding: 12px 16px;
  margin-bottom: 8px;
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
}

.personal-fields:hover {
  background-color: #FAFAFA;
  border-color: #E2E8F0 !important;
}

.personal-fields.has-error {
  border: 1.5px solid #DC3545 !important;
  background-color: #FFF5F5;
  border-radius: 10px;
  padding: 12px 16px;
}

.drawer-header-modern {
  padding: 16px 24px;
  background-color: #FFFFFF;
  border-bottom: 1px solid #F1F5F9;
}

.user-avatar-modern {
  width: 44px !important;
  height: 44px !important;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 18px;
  background: linear-gradient(135deg, #FDF7EE 0%, #F5E8D3 100%);
  color: #CBA370;
  border: 2px solid #FFFFFF;
  box-shadow: 0 2px 6px rgba(203, 163, 112, 0.2);
}

.field-icon-box {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background-color: #FAF5EE;
  color: #CBA370;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  flex-shrink: 0;
}

.field-label-text {
  font-size: 13.5px;
  font-weight: 500;
  color: #334155;
}

.field-value-text {
  color: #CBA370;
  font-weight: 600;
  font-size: 13.5px;
  text-align: right;
}

.btn-close-circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #E2E8F0;
  background: #FFFFFF;
  color: #64748B;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  cursor: pointer;
  padding: 0;
}

.btn-close-circle:hover {
  background: #F1F5F9;
  color: #0F172A;
  border-color: #CBD5E1;
}

.edit-input {
  border: 1px solid #E5E7EB;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 13.5px;
  width: 100%;
  color: #111827;
  background-color: #ffffff;
  transition: border-color 0.2s;
}

.edit-input:focus {
  border-color: #CBA370;
  outline: none;
  box-shadow: 0 0 0 3px rgba(203, 163, 112, 0.1);
}

.edit-input:disabled {
  background-color: #F9FAFB;
  cursor: not-allowed;
  color: #6B7280;
}

.edit-input.is-error {
  border-color: #DC3545;
}

.field-error-text {
  font-size: 11px;
  color: #DC3545;
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 3px;
}

.subscription-box {
  border-radius: 6px;
  background: #FFFFFF;
  margin-top: 14px;
}

.subscription-edit-section {
  background-color: #FFFAF0;
  border: 1px solid #CBA370;
  border-radius: 8px;
  padding: 16px;
  margin-top: 12px;
}

.subscription-edit-label {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 6px;
}

.subscription-select {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #E5E7EB;
  border-radius: 6px;
  font-size: 14px;
  background-color: white;
  color: #374151;
  transition: all 0.2s;
}

.subscription-select:focus {
  border-color: #CBA370;
  outline: none;
  box-shadow: 0 0 0 3px rgba(203, 163, 112, 0.1);
}

.question-section {
  border-left: 2px solid #CBA370;
  padding-left: 10px;
  margin-bottom: 14px;
  margin-top: 14px;
}

.question-title {
  font-size: 13px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 8px;
}

.option-item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.option-label {
  font-size: 13px;
  color: #374151;
  line-height: 1.3;
}

.checked-option {
  color: #CBA370;
  font-weight: 600;
}

.custom-radio {
  appearance: none;
  -webkit-appearance: none;
  width: 14px;
  height: 14px;
  border: 1.5px solid #9CA3AF;
  border-radius: 50%;
  position: relative;
  cursor: pointer;
  flex-shrink: 0;
  margin: 0;
}

.custom-radio:checked {
  border-color: #D4A373;
}

.custom-radio:checked::after {
  content: '';
  position: absolute;
  width: 6px;
  height: 6px;
  background: #D4A373;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.password-box {
  background: #F0FDF4;
  border: 1px solid #86EFAC;
  border-radius: 8px;
  padding: 12px 16px;
}
`;

const getTodayFormatted = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const calculateEndDate = (startDateStr, durationMonths, extensionMonths) => {
  if (!startDateStr) return '';
  const date = new Date(startDateStr);
  const totalMonths = (parseInt(durationMonths, 10) || 0) + (parseInt(extensionMonths, 10) || 0);
  date.setMonth(date.getMonth() + totalMonths);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const INITIAL_FORM_STATE = {
  FirstName: '',
  LastName: '',
  MobileNumber: '',
  EmailID: '',
  DOB: '',
  EmailAlert: true,
  PushAlert: true,
  Suspended: false, // IsActive is true; Suspended is false and disabled
  AssignSubscription: false, // Yes/No question
  SubscriptionID: '',
  DurationInMonths: '',
  ExtensionInMonths: 0,
  SubscriptionFee: 0,
  StartDate: getTodayFormatted(),
  SituationProfessionnelle: '',
  HorizonDePlacement: '',
  ObjectifDePlacement: [],
  AversionAuRisque: '',
  AppURL: 'https://amwaly.ma'
};

const FormQuestion = ({ question, options, selectedValue, icon, onOptionChange, field, error }) => (
  <div className="question-section">
    <div className="question-title d-flex align-items-center gap-2">
      <span style={{ color: '#CBA370' }}>{icon}</span>
      <span>{question} <span className="text-danger">*</span></span>
    </div>
    <div>
      {options.map((option, index) => (
        <div key={index} className="option-item">
          <input
            type="radio"
            name={field}
            id={`${field}-${index}`}
            checked={option === selectedValue}
            onChange={() => onOptionChange(field, option)}
            className="custom-radio"
            style={{ cursor: 'pointer' }}
          />
          <label
            htmlFor={`${field}-${index}`}
            className={`option-label mb-0 ${option === selectedValue ? 'checked-option' : ''}`}
            style={{ cursor: 'pointer' }}
          >
            {option}
          </label>
        </div>
      ))}
    </div>
    {error && (
      <div className="field-error-text mt-1">
        <AlertCircle size={12} />
        {error}
      </div>
    )}
  </div>
);

const MultiSelectQuestion = ({ question, options, selectedValues = [], icon, onOptionChange, field, error }) => (
  <div className="question-section">
    <div className="question-title d-flex align-items-center gap-2">
      <span style={{ color: '#CBA370' }}>{icon}</span>
      <span>{question} <span className="text-danger">*</span></span>
    </div>
    <div>
      {options.map((option, index) => (
        <div key={index} className="option-item">
          <input
            type="checkbox"
            id={`${field}-${index}`}
            checked={selectedValues.includes(option)}
            onChange={(e) => {
              const newValues = e.target.checked
                ? [...selectedValues, option]
                : selectedValues.filter(v => v !== option);
              onOptionChange(field, newValues);
            }}
            className="custom-radio"
            style={{ cursor: 'pointer' }}
          />
          <label
            htmlFor={`${field}-${index}`}
            className={`option-label mb-0 ${selectedValues.includes(option) ? 'checked-option' : ''}`}
            style={{ cursor: 'pointer' }}
          >
            {option}
          </label>
        </div>
      ))}
    </div>
    {error && (
      <div className="field-error-text mt-1">
        <AlertCircle size={12} />
        {error}
      </div>
    )}
  </div>
);

const CreateAppUserDrawer = ({ onClose, onSuccess }) => {
  const [formData, setFormData] = useState(INITIAL_FORM_STATE);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [subscriptionList, setSubscriptionList] = useState([]);
  const [loadingSubscriptions, setLoadingSubscriptions] = useState(false);
  const [professionalSituations, setProfessionalSituations] = useState([]);
  const [loadingSituations, setLoadingSituations] = useState(false);
  const [createdUserData, setCreatedUserData] = useState(null);
  const [showPassword, setShowPassword] = useState(true);
  const [copiedPassword, setCopiedPassword] = useState(false);

  // Body scroll locking
  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    const originalPosition = document.body.style.position;
    const originalWidth = document.body.style.width;
    const originalHeight = document.body.style.height;
    const originalTouchAction = document.body.style.touchAction;

    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.height = '100%';
    document.body.style.touchAction = 'none';
    document.body.classList.add('drawer-open');

    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && !loading) {
        onClose();
      }
    };
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.style.overflow = originalOverflow;
      document.body.style.position = originalPosition;
      document.body.style.width = originalWidth;
      document.body.style.height = originalHeight;
      document.body.style.touchAction = originalTouchAction;
      document.body.classList.remove('drawer-open');
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose, loading]);

  // Fetch Subscriptions and Professional Situations
  useEffect(() => {
    const fetchInitialData = async () => {
      setLoadingSubscriptions(true);
      try {
        const response = await getSubscriptions();
        let data = [];
        if (Array.isArray(response)) {
          data = response;
        } else if (response?.Data && Array.isArray(response.Data)) {
          data = response.Data;
        } else if (response?.data && Array.isArray(response.data)) {
          data = response.data;
        }
        setSubscriptionList(data || []);
      } catch (err) {
        console.error('Error fetching subscriptions:', err);
      } finally {
        setLoadingSubscriptions(false);
      }

      setLoadingSituations(true);
      try {
        const profRes = await getProfessionalSituation();
        if (profRes && profRes.Data) {
          const activeSituations = profRes.Data.filter(item => item.IsActive === '1' || item.IsActive === 1 || item.IsActive === true);
          setProfessionalSituations(activeSituations);
        }
      } catch (err) {
        console.error('Error fetching professional situations:', err);
      } finally {
        setLoadingSituations(false);
      }
    };

    fetchInitialData();
  }, []);

  // Filter subscription plans where IsActive = 1 and IsDefault = 0
  const eligibleSubscriptionPlans = useMemo(() => {
    return subscriptionList.filter((sub) => {
      const isActive = sub.IsActive === true || sub.IsActive === 1 || sub.IsActive === '1';
      const isDefault = sub.IsDefault === true || sub.IsDefault === 1 || sub.IsDefault === '1';
      return isActive && !isDefault;
    });
  }, [subscriptionList]);

  // Calculated End Date
  const calculatedEndDate = useMemo(() => {
    return calculateEndDate(formData.StartDate, formData.DurationInMonths, formData.ExtensionInMonths);
  }, [formData.StartDate, formData.DurationInMonths, formData.ExtensionInMonths]);

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value
    }));

    if (errors[field]) {
      setErrors((prev) => ({
        ...prev,
        [field]: ''
      }));
    }
  };

  const handleSubscriptionSelect = (e) => {
    const subId = e.target.value;
    if (!subId) {
      setFormData((prev) => ({
        ...prev,
        SubscriptionID: '',
        DurationInMonths: '',
        ExtensionInMonths: 0,
        SubscriptionFee: 0
      }));
      return;
    }

    const selectedSub = eligibleSubscriptionPlans.find((sub) => sub.ID === subId);
    if (selectedSub) {
      const duration = selectedSub.DurationInMonths || selectedSub.ActualDurationInMonths || 1;
      const extra = selectedSub.ExtraMonths || 0;
      const fee = selectedSub.SubscriptionFee || selectedSub.UndiscountedPrice || 0;

      setFormData((prev) => ({
        ...prev,
        SubscriptionID: subId,
        DurationInMonths: duration,
        ExtensionInMonths: extra,
        SubscriptionFee: fee
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        SubscriptionID: subId
      }));
    }

    if (errors.SubscriptionID) {
      setErrors((prev) => ({ ...prev, SubscriptionID: '' }));
    }
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.FirstName.trim()) {
      newErrors.FirstName = 'First Name is mandatory';
    }

    if (!formData.MobileNumber.trim()) {
      newErrors.MobileNumber = 'Mobile Number is mandatory';
    } else {
      const digits = formData.MobileNumber.replace(/\D/g, '');
      if (digits.length > 15) {
        newErrors.MobileNumber = 'Mobile number cannot exceed 15 digits';
      }
    }

    if (formData.DOB) {
      const dobDate = new Date(formData.DOB);
      const today = new Date();
      today.setHours(23, 59, 59, 999);
      if (isNaN(dobDate.getTime())) {
        newErrors.DOB = 'Please enter a valid date';
      } else if (dobDate > today) {
        newErrors.DOB = 'Date of birth cannot be in the future';
      }
    }

    if (!formData.EmailID.trim()) {
      newErrors.EmailID = 'Email ID is mandatory';
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.EmailID.trim())) {
        newErrors.EmailID = 'Please enter a valid email address';
      }
    }

    if (formData.AssignSubscription) {
      if (!formData.SubscriptionID) {
        newErrors.SubscriptionID = 'Please select a subscription plan';
      }
      if (formData.DurationInMonths === '' || Number(formData.DurationInMonths) < 1) {
        newErrors.DurationInMonths = 'Duration must be at least 1 month';
      }
      if (formData.ExtensionInMonths !== '' && Number(formData.ExtensionInMonths) < 0) {
        newErrors.ExtensionInMonths = 'Extension cannot be negative';
      }
      if (!formData.SituationProfessionnelle?.trim()) {
        newErrors.SituationProfessionnelle = 'Please select your professional situation';
      }
      if (!formData.HorizonDePlacement?.trim()) {
        newErrors.HorizonDePlacement = 'Please select your investment horizon';
      }
      const objectives = Array.isArray(formData.ObjectifDePlacement)
        ? formData.ObjectifDePlacement
        : (formData.ObjectifDePlacement ? [formData.ObjectifDePlacement] : []);
      if (objectives.length === 0) {
        newErrors.ObjectifDePlacement = 'Please select at least one investment objective';
      }
      if (!formData.AversionAuRisque?.trim()) {
        newErrors.AversionAuRisque = 'Please select your risk tolerance';
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();

    if (!validate()) {
      toast.error('Please fill in all mandatory fields.');
      return;
    }

    setLoading(true);

    try {
      const payload = {
        FirstName: formData.FirstName.trim(),
        LastName: formData.LastName.trim(),
        EmailID: formData.EmailID.trim(),
        MobileNumber: formData.MobileNumber.trim(),
        DOB: formData.DOB || undefined,
        EmailAlert: Boolean(formData.EmailAlert),
        PushAlert: Boolean(formData.PushAlert),
        IsActive: true, // Suspended = false means IsActive = true
        AppURL: formData.AppURL ? formData.AppURL.trim() : 'https://amwaly.ma'
      };

      if (formData.AssignSubscription && formData.SubscriptionID) {
        payload.SubscriptionID = formData.SubscriptionID;
        payload.DurationInMonths = Number(formData.DurationInMonths || 1);
        payload.ExtensionInMonths = Number(formData.ExtensionInMonths || 0);
        payload.SubscriptionFee = Number(formData.SubscriptionFee || 0);
        payload.PaymentAmount = Number(formData.SubscriptionFee || 0);
        payload.PaymentCurrency = 'MAD';
        payload.StartDate = formData.StartDate || getTodayFormatted();

        if (formData.SituationProfessionnelle) {
          payload.SituationProfessionnelle = formData.SituationProfessionnelle;
        }
        if (formData.HorizonDePlacement) {
          payload.HorizonDePlacement = formData.HorizonDePlacement;
        }
        if (formData.ObjectifDePlacement && formData.ObjectifDePlacement.length > 0) {
          payload.ObjectifDePlacement = formData.ObjectifDePlacement;
        }
        if (formData.AversionAuRisque) {
          payload.AversionAuRisque = formData.AversionAuRisque;
        }
      }

      const response = await createAppUser(payload);

      if (response && (response.Status === 'success' || response.status === 'success' || response.Data || response.data)) {
        const userData = response.Data || response.data || response;
        setCreatedUserData(userData);
        toast.success(response.Message || response.message || 'App user created successfully!');
        if (onSuccess) {
          onSuccess(userData);
        }
      } else {
        toast.error(response?.Message || response?.message || 'Failed to create app user');
      }
    } catch (error) {
      console.error('Error creating app user:', error);
      const errMsg = error.response?.data?.message || error.response?.data?.Message || error.message || 'Failed to create app user';
      toast.error(errMsg);
    } finally {
      setLoading(false);
    }
  };

  const handleCopyPassword = () => {
    if (createdUserData?.GeneratedPassword) {
      navigator.clipboard.writeText(createdUserData.GeneratedPassword);
      setCopiedPassword(true);
      toast.info('Password copied to clipboard!');
      setTimeout(() => setCopiedPassword(false), 2500);
    }
  };

  const handleResetAndCreateAnother = () => {
    setFormData(INITIAL_FORM_STATE);
    setErrors({});
    setCreatedUserData(null);
    setCopiedPassword(false);
  };

  const horizonOptions = [
    'Inférieur à 1 an',
    'Entre 1 an et 5 ans',
    'Supérieur à 5 ans'
  ];

  const objectifOptions = [
    'Construire un capital',
    'Générer un revenu complémentaire',
    'Préparer ma retraite',
    'Spéculer à court terme'
  ];

  const aversionOptions = [
    'Conservateur',
    'Modéré',
    'Entrepreneur'
  ];

  const drawerContent = (
    <>
      <style>{customStyles}</style>

      {/* Backdrop */}
      <div className="drawer-backdrop" onClick={loading ? undefined : onClose} />

      {/* Drawer */}
      <div className="user-drawer">
        {/* Header - Matching FilterUserDrawer */}
        <div className="drawer-header-modern">
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-3" style={{ minWidth: 0, flex: 1, marginRight: '12px' }}>
              <div className="user-avatar-modern">
                <Icon icon="solar:user-plus-bold" width={22} height={22} />
              </div>
              <div style={{ minWidth: 0, overflow: 'hidden' }}>
                <div style={{ color: '#0F172A', fontWeight: '700', fontSize: '18px', letterSpacing: '-0.2px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {createdUserData ? 'User Created Successfully' : 'Add New App User'}
                </div>
                <div className="text-secondary-light text-xs mt-1" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {createdUserData ? 'Account created and activated' : 'Fill details to create a new mobile application user'}
                </div>
              </div>
            </div>
            <button
              type="button"
              className="btn-close-circle"
              onClick={loading ? undefined : onClose}
              title="Close"
              style={{ flexShrink: 0 }}
            >
              <X size={18} />
            </button>
          </div>
        </div>

        {/* Scrollable Container */}
        <div style={{ overflowY: 'auto', overflowX: 'hidden', flex: 1, maxHeight: 'calc(100vh - 85px)', padding: '16px 20px', boxSizing: 'border-box', width: '100%' }}>
          {createdUserData ? (
            /* Success State */
            <div>
              <div
                className="p-16 radius-8 mb-16 text-center"
                style={{ backgroundColor: '#F0FDF4', border: '1px solid #BBF7D0' }}
              >
                <div
                  className="d-inline-flex align-items-center justify-content-center radius-circle mb-10"
                  style={{ width: '48px', height: '48px', backgroundColor: '#DCFCE7', color: '#16A34A' }}
                >
                  <Check size={28} />
                </div>
                <h6 className="fw-bold mb-4" style={{ color: '#15803D', fontSize: '16px' }}>
                  App User Created Successfully!
                </h6>
                <p className="text-secondary-light mb-0" style={{ fontSize: '13px' }}>
                  The user account is now active and ready for login.
                </p>
              </div>

              {/* User Credentials */}
              <div className="personal-fields">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center">
                    <span className="field-icon-box"><User size={16} /></span>
                    <span className="field-label-text">Full Name</span>
                  </div>
                  <span className="field-value-text">
                    {createdUserData.FullName || `${createdUserData.FirstName} ${createdUserData.LastName}`}
                  </span>
                </div>
              </div>

              <div className="personal-fields">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center">
                    <span className="field-icon-box"><Mail size={16} /></span>
                    <span className="field-label-text">Email / Username</span>
                  </div>
                  <span className="field-value-text">
                    {createdUserData.EMailID || createdUserData.Username}
                  </span>
                </div>
              </div>

              {createdUserData.ContactNumber && (
                <div className="personal-fields">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                      <span className="field-icon-box"><Phone size={16} /></span>
                      <span className="field-label-text">Mobile Number</span>
                    </div>
                    <span className="field-value-text">
                      {createdUserData.ContactNumber}
                    </span>
                  </div>
                </div>
              )}

              {/* Generated Password Box */}
              {createdUserData.GeneratedPassword && (
                <div className="mt-16 password-box">
                  <label className="text-xs fw-bold d-block mb-1" style={{ color: '#166534' }}>
                    GENERATED TEMPORARY PASSWORD
                  </label>
                  <div className="d-flex align-items-center justify-content-between gap-2">
                    <code
                      className="fw-bold"
                      style={{
                        fontSize: '16px',
                        color: '#15803D',
                        letterSpacing: showPassword ? '1px' : '3px'
                      }}
                    >
                      {showPassword ? createdUserData.GeneratedPassword : '••••••••••'}
                    </code>
                    <div className="d-flex align-items-center gap-2">
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-success p-1 radius-6 d-flex align-items-center justify-content-center"
                        style={{ width: '30px', height: '30px' }}
                        onClick={() => setShowPassword((prev) => !prev)}
                        title={showPassword ? 'Hide password' : 'Show password'}
                      >
                        {showPassword ? <EyeOff size={14} /> : <Eye size={14} />}
                      </button>
                      <button
                        type="button"
                        className="btn btn-sm btn-success px-12 py-4 radius-6 d-flex align-items-center gap-1"
                        onClick={handleCopyPassword}
                        style={{ fontSize: '12px' }}
                      >
                        {copiedPassword ? (
                          <>
                            <Check size={13} /> Copied!
                          </>
                        ) : (
                          <>
                            <Copy size={13} /> Copy
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* Subscription details if assigned */}
              {createdUserData.Subscription && (
                <div className="mt-16 p-12 rounded" style={{ backgroundColor: '#F9FAFB', border: '1px solid #E5E7EB' }}>
                  <div className="d-flex align-items-center gap-2 mb-8">
                    <Shield size={15} color="#CBA370" />
                    <span className="fw-semibold text-sm" style={{ color: '#374151' }}>
                      Assigned Subscription Plan
                    </span>
                  </div>
                  <div className="row g-2 text-xs">
                    <div className="col-6">
                      <span className="text-muted d-block">Start Date</span>
                      <span className="fw-semibold text-dark">{createdUserData.Subscription.StartDate || 'N/A'}</span>
                    </div>
                    <div className="col-6">
                      <span className="text-muted d-block">End Date</span>
                      <span className="fw-semibold" style={{ color: '#CBA370' }}>
                        {createdUserData.Subscription.EndDate || 'N/A'}
                      </span>
                    </div>
                    <div className="col-6 mt-2">
                      <span className="text-muted d-block">Duration</span>
                      <span className="fw-medium">
                        {(createdUserData.Subscription.DurationInMonths - createdUserData.Subscription.ExtensionInMonths) || (createdUserData.Subscription.PaymentDuration - createdUserData.Subscription.ExtensionInMonths)} months
                      </span>
                    </div>
                    {createdUserData.Subscription.ExtensionInMonths > 0 && (
                      <div className="col-6 mt-2">
                        <span className="text-muted d-block">Extension</span>
                        <span className="fw-medium text-success">
                          +{createdUserData.Subscription.ExtensionInMonths} months
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Success Actions */}
              <div className="d-flex justify-content-end gap-2 mt-16 pt-3 border-top">
                <Button
                  variant="outline-secondary"
                  size="sm"
                  className="d-flex align-items-center gap-1 px-14 py-6"
                  style={{ borderColor: '#D1D5DB', color: '#6B7280', borderRadius: '8px' }}
                  onClick={handleResetAndCreateAnother}
                >
                  <PlusCircle size={14} />
                  Create Another
                </Button>
                <Button
                  variant="primary"
                  size="sm"
                  className="btn btn-primary d-flex align-items-center gap-1 px-16 py-6"
                  style={{ borderRadius: '8px' }}
                  onClick={onClose}
                >
                  Done & Close
                </Button>
              </div>
            </div>
          ) : (
            /* Creation Form */
            <div>
              <div className="w-100">
                {/* First Name (Mandatory) */}
                <div className={`personal-fields ${errors.FirstName ? 'has-error' : ''}`}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center" style={{ width: '40%' }}>
                      <span className="field-icon-box">
                        <User size={16} />
                      </span>
                      <span className="field-label-text">
                        First Name <span className="text-danger">*</span>
                      </span>
                    </div>
                    <div className="d-flex flex-column align-items-end" style={{ width: '60%' }}>
                      <input
                        type="text"
                        className={`edit-input ${errors.FirstName ? 'is-error' : ''}`}
                        placeholder="Enter first name"
                        value={formData.FirstName}
                        onChange={(e) => handleChange('FirstName', e.target.value)}
                        disabled={loading}
                      />
                      {errors.FirstName && (
                        <div className="field-error-text">
                          <AlertCircle size={12} />
                          {errors.FirstName}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Last Name (Optional) */}
                <div className="personal-fields">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center" style={{ width: '40%' }}>
                      <span className="field-icon-box">
                        <User size={16} />
                      </span>
                      <span className="field-label-text">Last Name</span>
                    </div>
                    <div className="d-flex flex-column align-items-end" style={{ width: '60%' }}>
                      <input
                        type="text"
                        className="edit-input"
                        placeholder="Enter last name"
                        value={formData.LastName}
                        onChange={(e) => handleChange('LastName', e.target.value)}
                        disabled={loading}
                      />
                    </div>
                  </div>
                </div>

                {/* Mobile Number (Mandatory) */}
                <div className={`personal-fields ${errors.MobileNumber ? 'has-error' : ''}`}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center" style={{ width: '40%' }}>
                      <span className="field-icon-box">
                        <Phone size={16} />
                      </span>
                      <span className="field-label-text">
                        Mobile Number <span className="text-danger">*</span>
                      </span>
                    </div>
                    <div className="d-flex flex-column align-items-end" style={{ width: '60%' }}>
                      <input
                        type="tel"
                        className={`edit-input ${errors.MobileNumber ? 'is-error' : ''}`}
                        placeholder="e.g. +212612345678"
                        value={formData.MobileNumber}
                        onChange={(e) => handleChange('MobileNumber', e.target.value)}
                        disabled={loading}
                      />
                      {errors.MobileNumber && (
                        <div className="field-error-text">
                          <AlertCircle size={12} />
                          {errors.MobileNumber}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Email ID (Mandatory) */}
                <div className={`personal-fields ${errors.EmailID ? 'has-error' : ''}`}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center" style={{ width: '40%' }}>
                      <span className="field-icon-box">
                        <Mail size={16} />
                      </span>
                      <span className="field-label-text">
                        Email ID <span className="text-danger">*</span>
                      </span>
                    </div>
                    <div className="d-flex flex-column align-items-end" style={{ width: '60%' }}>
                      <input
                        type="email"
                        className={`edit-input ${errors.EmailID ? 'is-error' : ''}`}
                        placeholder="e.g. user@example.com"
                        value={formData.EmailID}
                        onChange={(e) => handleChange('EmailID', e.target.value)}
                        disabled={loading}
                      />
                      {errors.EmailID && (
                        <div className="field-error-text">
                          <AlertCircle size={12} />
                          {errors.EmailID}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Date of Birth (DOB) */}
                <div className={`personal-fields ${errors.DOB ? 'has-error' : ''}`}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center" style={{ width: '40%' }}>
                      <span className="field-icon-box">
                        <Calendar size={16} />
                      </span>
                      <span className="field-label-text">Date of Birth</span>
                    </div>
                    <div className="d-flex flex-column align-items-end" style={{ width: '60%' }}>
                      <input
                        type="date"
                        className={`edit-input ${errors.DOB ? 'is-error' : ''}`}
                        max={getTodayFormatted()}
                        value={formData.DOB}
                        onChange={(e) => handleChange('DOB', e.target.value)}
                        disabled={loading}
                      />
                      {errors.DOB && (
                        <div className="field-error-text">
                          <AlertCircle size={12} />
                          {errors.DOB}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Email Alert (Switch, default true) */}
                <div className="personal-fields">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                      <span className="field-icon-box">
                        <Mail size={16} />
                      </span>
                      <span className="field-label-text">Subscription for email alert</span>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      <Form.Check
                        type="switch"
                        id="email-alert-switch"
                        checked={formData.EmailAlert}
                        onChange={(e) => handleChange('EmailAlert', e.target.checked)}
                        disabled={loading}
                      />
                      <span className="field-value-text">
                        {formData.EmailAlert ? 'Yes' : 'No'}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Push Alert (Switch, default true) */}
                <div className="personal-fields">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                      <span className="field-icon-box">
                        <Icon icon="solar:bell-linear" width={16} height={16} />
                      </span>
                      <span className="field-label-text">Subscription for Push Notification alert</span>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      <Form.Check
                        type="switch"
                        id="push-alert-switch"
                        checked={formData.PushAlert}
                        onChange={(e) => handleChange('PushAlert', e.target.checked)}
                        disabled={loading}
                      />
                      <span className="field-value-text">
                        {formData.PushAlert ? 'Yes' : 'No'}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Suspended (IsActive) - Default false and disabled */}
                <div className="personal-fields">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                      <span className="field-icon-box">
                        <Shield size={16} />
                      </span>
                      <div>
                        <span className="field-label-text">Suspended</span>
                      </div>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      <Form.Check
                        type="switch"
                        id="suspended-switch"
                        checked={false}
                        disabled={true}
                      />
                      <span style={{ color: '#6B7280', fontWeight: '500', fontSize: '14px' }}>
                        False
                      </span>
                    </div>
                  </div>
                </div>


                {/* Subscription Question: Yes/No */}
                <div
                  className="personal-fields mt-3"
                  style={{
                    backgroundColor: '#FFFDF9',
                    border: '1px solid #E6D2B5',
                    padding: '14px 16px',
                    borderRadius: '10px',
                  }}
                >
                  <div
                    className="d-flex align-items-center justify-content-between"
                    style={{ gap: '16px', flexWrap: 'wrap' }}
                  >
                    {/* Question */}
                    <div className="d-flex align-items-center" style={{ gap: '12px', flex: '1 1 240px' }}>
                      <span className="field-icon-box" style={{ marginRight: 0 }}>
                        <Shield size={16} />
                      </span>

                      <span
                        style={{
                          color: '#111827',
                          fontSize: '14px',
                          fontWeight: '600',
                          lineHeight: '1.5',
                        }}
                      >
                        Do you want to assign any Subscription?
                      </span>
                    </div>

                    {/* Yes / No Radio Buttons */}
                    <div
                      className="d-flex align-items-center"
                      style={{
                        gap: '18px',
                        flexShrink: 0,
                        marginLeft: 'auto',
                      }}
                    >
                      <label
                        htmlFor="assignSubYes"
                        className="d-inline-flex align-items-center mb-0"
                        style={{
                          gap: '7px',
                          cursor: 'pointer',
                          color: '#111827',
                          fontSize: '13px',
                          fontWeight: '600',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        <input
                          className="form-check-input m-0"
                          type="radio"
                          name="assignSubscriptionRadio"
                          id="assignSubYes"
                          checked={formData.AssignSubscription === true}
                          onChange={() => handleChange('AssignSubscription', true)}
                          disabled={loading}
                          style={{
                            cursor: 'pointer',
                            accentColor: '#CBA370',
                            width: '16px',
                            height: '16px',
                            flexShrink: 0,
                          }}
                        />
                        Yes
                      </label>

                      <label
                        htmlFor="assignSubNo"
                        className="d-inline-flex align-items-center mb-0"
                        style={{
                          gap: '7px',
                          cursor: 'pointer',
                          color: '#111827',
                          fontSize: '13px',
                          fontWeight: '600',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        <input
                          className="form-check-input m-0"
                          type="radio"
                          name="assignSubscriptionRadio"
                          id="assignSubNo"
                          checked={formData.AssignSubscription === false}
                          onChange={() => {
                            setFormData((prev) => ({
                              ...prev,
                              AssignSubscription: false,
                              SubscriptionID: '',
                              DurationInMonths: '',
                              ExtensionInMonths: 0,
                              SubscriptionFee: 0,
                              SituationProfessionnelle: '',
                              HorizonDePlacement: '',
                              ObjectifDePlacement: [],
                              AversionAuRisque: '',
                            }));

                            setErrors((prev) => ({
                              ...prev,
                              SubscriptionID: '',
                              DurationInMonths: '',
                              ExtensionInMonths: '',
                              SituationProfessionnelle: '',
                              HorizonDePlacement: '',
                              ObjectifDePlacement: '',
                              AversionAuRisque: '',
                            }));
                          }}
                          disabled={loading}
                          style={{
                            cursor: 'pointer',
                            accentColor: '#CBA370',
                            width: '16px',
                            height: '16px',
                            flexShrink: 0,
                          }}
                        />
                        No
                      </label>
                    </div>
                  </div>
                </div>


                {/* Subscription Details & Investment Criteria (When YES) */}
                {formData.AssignSubscription && (
                  <div className="subscription-edit-section mt-3">
                    <div className="d-flex align-items-center gap-2 mb-3">
                      <Calendar size={16} color="#CBA370" />
                      <span style={{ fontSize: '14px', fontWeight: '600', color: '#111827' }}>
                        Subscription Configuration
                      </span>
                    </div>

                    {/* Dropdown with IsActive = 1 and IsDefault = 0 */}
                    <div className="mb-3">
                      <div className="subscription-edit-label">
                        Subscription Plan <span className="text-danger">*</span>
                      </div>
                      {loadingSubscriptions ? (
                        <div className="d-flex align-items-center gap-2 text-muted text-xs py-2">
                          <Spinner animation="border" size="sm" />
                          Loading subscription plans...
                        </div>
                      ) : (
                        <select
                          className={`subscription-select ${errors.SubscriptionID ? 'is-invalid' : ''}`}
                          value={formData.SubscriptionID}
                          onChange={handleSubscriptionSelect}
                          disabled={loading}
                        >
                          <option value="">Select Subscription Plan</option>
                          {eligibleSubscriptionPlans.map((sub) => (
                            <option key={sub.ID} value={sub.ID}>
                              {sub.SubscriptionName || 'Plan'} - {sub.SubscriptionFee ? `${sub.SubscriptionFee} MAD` : 'Free'}
                            </option>
                          ))}
                        </select>
                      )}
                      {errors.SubscriptionID && (
                        <div className="field-error-text">
                          <AlertCircle size={12} />
                          {errors.SubscriptionID}
                        </div>
                      )}
                    </div>

                    {/* Duration (in Month) [DISABLED] & Extension (in Month) [ENABLED] */}
                    <div className="row g-2 mb-3">
                      <div className="col-6">
                        <label className="subscription-edit-label">
                          Duration (in Month)
                        </label>
                        <input
                          type="number"
                          className="edit-input"
                          value={formData.DurationInMonths}
                          disabled={true}
                          placeholder="Auto-filled"
                        />
                      </div>
                      <div className="col-6">
                        <label className="subscription-edit-label">
                          Extension (in Month)
                        </label>
                        <input
                          type="number"
                          min="0"
                          step="1"
                          className={`edit-input ${errors.ExtensionInMonths ? 'is-error' : ''}`}
                          value={formData.ExtensionInMonths}
                          onChange={(e) => handleChange('ExtensionInMonths', e.target.value)}
                          disabled={loading || !formData.SubscriptionID}
                          placeholder="0"
                        />
                        {errors.ExtensionInMonths && (
                          <div className="field-error-text">
                            <AlertCircle size={12} />
                            {errors.ExtensionInMonths}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Start Date & End Date calculation preview */}
                    <div className="p-12 rounded mb-3" style={{ backgroundColor: '#FFFFFF', border: '1px solid #E5E7EB' }}>
                      <div className="row g-2 text-xs">
                        <div className="col-6">
                          <span className="text-muted d-block">Start Date (Today)</span>
                          <span className="fw-semibold text-dark" style={{ fontSize: '13px' }}>
                            {formData.StartDate}
                          </span>
                        </div>
                        <div className="col-6">
                          <span className="text-muted d-block">End Date</span>
                          <span className="fw-semibold" style={{ color: '#CBA370', fontSize: '13px' }}>
                            {calculatedEndDate || 'N/A'}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Situation Professionnelle */}
                    <div className="mb-3">
                      <div className="subscription-edit-label">
                        Situation Professionnelle <span className="text-danger">*</span>
                      </div>
                      <select
                        className={`subscription-select ${errors.SituationProfessionnelle ? 'border-danger' : ''}`}
                        value={formData.SituationProfessionnelle}
                        onChange={(e) => handleChange('SituationProfessionnelle', e.target.value)}
                        disabled={loading || loadingSituations}
                      >
                        <option value="">Select Situation</option>
                        {professionalSituations.map((situation) => (
                          <option key={situation.ID} value={situation.Value}>
                            {situation.Value}
                          </option>
                        ))}
                      </select>
                      {errors.SituationProfessionnelle && (
                        <div className="field-error-text mt-1">
                          <AlertCircle size={12} />
                          {errors.SituationProfessionnelle}
                        </div>
                      )}
                    </div>

                    {/* Horizon De Placement */}
                    <FormQuestion
                      question="Quel est votre horizon de placement ?"
                      options={horizonOptions}
                      selectedValue={formData.HorizonDePlacement}
                      icon={<Clock size={16} />}
                      onOptionChange={handleChange}
                      field="HorizonDePlacement"
                      error={errors.HorizonDePlacement}
                    />

                    {/* Objectif De Placement */}
                    <MultiSelectQuestion
                      question="Quel est votre objectif de placement ?"
                      options={objectifOptions}
                      selectedValues={formData.ObjectifDePlacement}
                      icon={<Target size={16} />}
                      onOptionChange={handleChange}
                      field="ObjectifDePlacement"
                      error={errors.ObjectifDePlacement}
                    />

                    {/* Aversion Au Risque */}
                    <FormQuestion
                      question="Quel est votre aversion au risque ?"
                      options={aversionOptions}
                      selectedValue={formData.AversionAuRisque}
                      icon={<Shield size={16} />}
                      onOptionChange={handleChange}
                      field="AversionAuRisque"
                      error={errors.AversionAuRisque}
                    />
                  </div>
                )}

                {/* Action Buttons - Matching FilterUserDrawer and Site style */}
                <div className="d-flex justify-content-end gap-2 mt-4 pt-2">
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    onClick={onClose}
                    disabled={loading}
                    className="d-flex align-items-center gap-1"
                    style={{ borderColor: '#D1D5DB', color: '#6B7280' }}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="button"
                    variant="primary"
                    size="sm"
                    className="btn btn-primary d-flex align-items-center gap-2"
                    onClick={handleSubmit}
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <Spinner animation="border" size="sm" />
                        <span>Creating...</span>
                      </>
                    ) : (
                      <>
                        <Icon icon="solar:user-plus-bold" width={16} height={16} />
                        <span>Create App User</span>
                      </>
                    )}
                  </Button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );

  return ReactDOM.createPortal(drawerContent, document.body);
};

export default CreateAppUserDrawer;
